import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { DatasetRead } from "@/types/datasets";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";
import { PaginatedResponse } from "../types";

interface DatasetParams {
  prompt_id?: number;
  prompt_version_id?: number;
  prompt_label_id?: number;
  report_id?: number;
  page?: number;
  per_page: number;
}

export const useDatasetsFromPipeline = (
  workspaceId: number,
  params: DatasetParams,
) => {
  const userToken = useAuth()?.userToken!;

  return useQuery<
    PaginatedResponse<{ datasets: DatasetRead[] }, "datasets", string>,
    Error
  >(
    [ENDPOINTS.datasets_from_prompt_id(workspaceId), params],
    async () => {
      const queryParams = new URLSearchParams({
        ...(params.prompt_id && { prompt_id: params.prompt_id.toString() }),
        ...(params.prompt_version_id && {
          prompt_version_id: params.prompt_version_id.toString(),
        }),
        ...(params.prompt_label_id && {
          prompt_label_id: params.prompt_label_id.toString(),
        }),
        ...(params.report_id && { report_id: params.report_id.toString() }),
        page: (params.page || 1).toString(),
        per_page: params.per_page.toString(),
      });

      return fetch(
        `${ENDPOINTS.datasets_from_prompt_id(
          workspaceId,
        )}?${queryParams.toString()}`,
        {
          method: "GET",
          headers: authHeader(userToken),
        },
      ).then(handleResponse);
    },
    { enabled: !!params.report_id },
  );
};
